var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2453_97621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61236 3H13.6304L18.7308 8.31635V18.6567C18.7308 19.952 17.6828 21 16.392 21H7.61236C6.31702 21 5.26904 19.952 5.26904 18.6567V5.34332C5.26902 4.04797 6.31699 3 7.61236 3Z",
    fill: "#E5252A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6255 3V8.27586H18.7304L13.6255 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87305 16.4303V13.1425H9.27185C9.61818 13.1425 9.89255 13.2369 10.0994 13.4303C10.3063 13.6192 10.4098 13.8756 10.4098 14.1949C10.4098 14.5143 10.3063 14.7706 10.0994 14.9595C9.89255 15.153 9.61818 15.2474 9.27185 15.2474H8.71413V16.4303H7.87305ZM8.71413 14.5323H9.1774C9.30333 14.5323 9.40228 14.5053 9.46976 14.4423C9.53722 14.3839 9.57322 14.3029 9.57322 14.195C9.57322 14.087 9.53724 14.0061 9.46976 13.9476C9.40231 13.8846 9.30335 13.8576 9.1774 13.8576H8.71413V14.5323ZM10.7561 16.4303V13.1425H11.921C12.1504 13.1425 12.3663 13.1739 12.5687 13.2414C12.7711 13.3089 12.9555 13.4033 13.1174 13.5338C13.2793 13.6597 13.4098 13.8306 13.5042 14.0465C13.5942 14.2624 13.6437 14.5098 13.6437 14.7886C13.6437 15.063 13.5942 15.3104 13.5042 15.5263C13.4098 15.7422 13.2793 15.9131 13.1174 16.039C12.9555 16.1694 12.7711 16.2639 12.5687 16.3314C12.3663 16.3988 12.1504 16.4303 11.921 16.4303H10.7561ZM11.5792 15.7152H11.8221C11.9525 15.7152 12.0739 15.7017 12.1864 15.6702C12.2943 15.6387 12.3978 15.5892 12.4967 15.5218C12.5912 15.4543 12.6676 15.3598 12.7216 15.2339C12.7756 15.108 12.8026 14.9595 12.8026 14.7886C12.8026 14.6132 12.7756 14.4648 12.7216 14.3389C12.6676 14.2129 12.5912 14.1185 12.4967 14.051C12.3978 13.9836 12.2943 13.9341 12.1864 13.9026C12.0739 13.8711 11.9525 13.8576 11.8221 13.8576H11.5792V15.7152ZM14.0665 16.4303V13.1425H16.4053V13.8576H14.9075V14.3838H16.1039V15.0945H14.9075V16.4303H14.0665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2453_97621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.16281751f0956bb2303fd3b3469471c8.svg";
export { ForwardRef as ReactComponent };